import { useState, useEffect } from 'react';
import { getStaffList, updateStaffMember, addStaffMember, type StaffMember } from '../utils/api';

export function StaffPage(): React.JSX.Element {
  const [staff, setStaff] = useState<StaffMember[]>([]);
  const [editingId, setEditingId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  // Получаем initData от Telegram
  const initData = (window as any).Telegram?.WebApp?.initData || 'test_init_data';

  useEffect(() => {
    const fetchStaff = async () => {
      const res = await getStaffList(initData);
      if (res.ok) {
        setStaff(res.value.staff);
      }
      setLoading(false);
    };
    fetchStaff();
  }, [initData]);

  const togglePermission = async (staffId: string, perm: string) => {
    const member = staff.find(s => s.id === staffId);
    if (!member) return;

    // Оптимистичное обновление UI
    const newValue = !member.permissions[perm];
    setStaff(prev => prev.map(s => s.id === staffId 
      ? { ...s, permissions: { ...s.permissions, [perm]: newValue } } 
      : s
    ));

    // Отправка на сервер
    const res = await updateStaffMember(initData, staffId, { 
      permissions: { ...member.permissions, [perm]: newValue } 
    });
    
    // Если ошибка — откатываем (в идеале)
    if (!res.ok) {
      console.error('Failed to update permissions', res.error);
    }
  };

  const handleAddStaff = async () => {
    const res = await addStaffMember(initData, 'Новый Сотрудник', 'master');
    if (res.ok) {
      setStaff(prev => [...prev, res.value.member]);
    } else {
      alert('Ошибка при добавлении сотрудника');
    }
  };

  if (loading) {
    return <div className="p-1">Загрузка команды...</div>;
  }

  return (
    <div className="p-1">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>👥 Моя команда</h1>
        <button onClick={handleAddStaff} className="status-badge status-confirmed" style={{ border: 'none', cursor: 'pointer' }}>+ Пригласить</button>
      </div>

      <div className="space-y-4">
        {staff.length === 0 && (
          <div style={{ textAlign: 'center', color: 'var(--tg-hint)', marginTop: '40px' }}>
            Сотрудников пока нет. Добавьте первого!
          </div>
        )}
        {staff.map(member => (
          <div key={member.id} className="card-premium" style={{ marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
              <div>
                <div style={{ fontWeight: 'bold', fontSize: '18px' }}>{member.name}</div>
                <div style={{ fontSize: '12px', color: 'var(--tg-hint)', textTransform: 'uppercase' }}>{member.role}</div>
              </div>
              <button 
                onClick={() => setEditingId(editingId === member.id ? null : member.id)}
                style={{ background: 'none', border: 'none', color: 'var(--tg-btn)', fontWeight: 'bold', cursor: 'pointer' }}
              >
                {editingId === member.id ? 'Закрыть' : 'Права ⚙️'}
              </button>
            </div>

            {editingId === member.id && (
              <div style={{ marginTop: '15px', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '15px' }}>
                <div className="section-title" style={{ fontSize: '12px', margin: '0 0 10px 0' }}>Настройка доступа</div>
                
                <PermissionToggle 
                  label="Видеть все записи" 
                  active={member.permissions?.viewAllBookings || false} 
                  onToggle={() => togglePermission(member.id, 'viewAllBookings')} 
                />
                <PermissionToggle 
                  label="Управление расписанием" 
                  active={member.permissions?.manageSchedule || false} 
                  onToggle={() => togglePermission(member.id, 'manageSchedule')} 
                />
                <PermissionToggle 
                  label="Управление персоналом" 
                  active={member.permissions?.manageStaff || false} 
                  onToggle={() => togglePermission(member.id, 'manageStaff')} 
                />
                <PermissionToggle 
                  label="Просмотр аналитики" 
                  active={member.permissions?.viewAnalytics === 'full' || member.permissions?.viewAnalytics === 'partial'} 
                  onToggle={() => togglePermission(member.id, 'viewAnalytics')} 
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function PermissionToggle({ label, active, onToggle }: { label: string, active: boolean, onToggle: () => void }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
      <span style={{ fontSize: '14px' }}>{label}</span>
      <div 
        onClick={onToggle}
        style={{ 
          width: '40px', 
          height: '20px', 
          backgroundColor: active ? 'var(--tg-btn)' : '#ccc', 
          borderRadius: '10px',
          position: 'relative',
          cursor: 'pointer',
          transition: '0.3s'
        }}
      >
        <div style={{ 
          width: '16px', 
          height: '16px', 
          backgroundColor: 'white', 
          borderRadius: '50%', 
          position: 'absolute', 
          top: '2px', 
          left: active ? '22px' : '2px',
          transition: '0.3s'
        }} />
      </div>
    </div>
  );
}
